import React from "react";

// Barra de paginação reutilizável (estilo Qive): seletor de resultados por
// página + "Mostrando X–Y de Z" + Anterior/Próxima.
// Modos:
//  - total != null  -> client-side (sabe o total): calcula intervalo e canNext.
//  - total == null  -> server-side: usa `hasNext` e mostra "Página N".
const DEFAULT_OPTIONS = [25, 50, 100];

const PaginationBar = ({
  page = 0,
  pageSize = 25,
  total = null,
  hasNext = false,
  onPageChange,
  onPageSizeChange,
  options = DEFAULT_OPTIONS,
  className = "",
}) => {
  const knowsTotal = total !== null && total !== undefined;
  const start = page * pageSize;
  const end = knowsTotal ? Math.min(start + pageSize, total) : start + pageSize;
  const canPrev = page > 0;
  const canNext = knowsTotal ? end < total : hasNext;

  const rangeText = knowsTotal
    ? total === 0
      ? "Nenhum resultado"
      : `Mostrando ${start + 1}–${end} de ${total}`
    : `Página ${page + 1}`;

  const btn =
    "rounded-md border border-border px-3 py-1.5 text-sm font-medium text-foreground hover:bg-muted disabled:opacity-40 disabled:cursor-not-allowed";

  return (
    <div
      className={`flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between pt-3 ${className}`}
    >
      <div className="flex items-center gap-2 text-sm text-muted-foreground">
        <span>Resultados por página</span>
        <select
          value={pageSize}
          onChange={(e) => onPageSizeChange?.(Number(e.target.value))}
          className="rounded-md border border-border bg-card px-2 py-1 text-sm text-foreground focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          {options.map((o) => (
            <option key={o} value={o}>
              {o}
            </option>
          ))}
        </select>
      </div>

      <div className="flex items-center gap-3">
        <span className="text-sm text-muted-foreground">{rangeText}</span>
        <div className="flex items-center gap-2">
          <button
            type="button"
            className={btn}
            disabled={!canPrev}
            onClick={() => onPageChange?.(page - 1)}
          >
            Anterior
          </button>
          <button
            type="button"
            className={btn}
            disabled={!canNext}
            onClick={() => onPageChange?.(page + 1)}
          >
            Próxima
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaginationBar;
